import { UserCalendarProvider } from 'generated-graphql/types';
import { UseUserCalendarReturnData } from 'modules/calendar/hooks/useUserCalendar';

// Shared with the form schema so field visibility and validation can't disagree.
export const getParticipantStats = (
  ownerId: string | null | undefined,
  participantIds: (string | undefined)[] | undefined,
  userCalendars: UseUserCalendarReturnData
): { participantCount: number; hasVirtualParticipant: boolean } => {
  const ids = [ownerId, ...(participantIds ?? [])].filter((id): id is string =>
    Boolean(id)
  );

  return {
    participantCount: ids.length,
    hasVirtualParticipant: ids.some(
      (id) =>
        userCalendars.find((calendar) => calendar.id === id)?.provider ===
        UserCalendarProvider.Virtual
    )
  };
};
